module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-crm/05-75e8524bbd3ee623acfb5e04da2b2a25.png";